import React, { createContext, Dispatch  } from 'react';
import dayjs, {Dayjs} from 'dayjs'
import { Enum } from "../resources/constants";

// Interfaces
import { Source, Tender, Filter, PrimaryFilter } from "../interfaces/pages/opportunities";

const { TopFilter, Source: SourceEnum } = Enum

export default createContext<{ user: { avatar: string|null, firstName?: string, lastName?: string, email: string|null, otp: boolean, roles: string[] }|null, accessToken: null|string, defaultSource: string, sources: Source[], tendersDashboard: { [source: string]: number }, tenders: Tender[], tendersPagination: { page: number, pageSize: number, total: number }, filter: Filter, primaryFilter: PrimaryFilter, topFilters: string[], postedDate: [Dayjs, Dayjs]|null, dispatch: Dispatch<{ type: string, payload: object }> }>({
    user: { avatar: null, email: null, otp: false, roles: [] },
    accessToken: null,
    sources: [],
    defaultSource: SourceEnum.US_Tenders,
    tendersDashboard: Object.fromEntries(Object.values(SourceEnum).map(item => [item, 0])),
    tenders: [],
    tendersPagination: {
        page: 1,
        pageSize: 6,
        total: 0,
    },
    filter: {},
    primaryFilter: {
        expired: true,
        eligible: true,
    },
    topFilters: [TopFilter.Basic_Search, TopFilter.Felix_Fusion_Picks],
    postedDate: null,
    dispatch: () => {}
})
